import { Injectable } from '@angular/core';
import { StartEndDate } from 'app/models/container-occupancy-empty-full-rate.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "app/app-initialization.service";
export class SimulationService {
    constructor(_httpClient, appConfigService) {
        this._httpClient = _httpClient;
        this.appConfigService = appConfigService;
    }
    getCars(companyId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/cars/" + companyId)
                .subscribe((response) => {
                this.cars = response;
                resolve(response);
            }, reject);
        });
    }
    getByPolygon(polygonId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/cars/getbypolygon?polygonId=" + polygonId)
                .subscribe((response) => {
                this.cars = response;
                resolve(response);
            }, reject);
        });
    }
    getByCar(plate) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/cars/getbycar?plate=" + plate)
                .subscribe((response) => {
                this.cars = response;
                resolve(response);
            }, reject);
        });
    }
    addCar(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/simulations/cars/add", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    updatedCar(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/cars/update", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    deleteCar(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/cars/delete", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getPoligons(companyId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/" + companyId)
                .subscribe((response) => {
                this.poligon = response;
                resolve(response);
            }, reject);
        });
    }
    getByPoligon(poligonId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/getbypolygon?id=" + poligonId)
                .subscribe((response) => {
                this.poligon = response;
                resolve(response);
            }, reject);
        });
    }
    getByPoligonDetail(discriminator_Id) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/GetbyPoligonDetail/" + discriminator_Id)
                .subscribe((response) => {
                this.poligon = response;
                resolve(response);
            }, reject);
        });
    }
    getPoligonDetail(poligonId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/GetbyDetail/" + poligonId)
                .subscribe((response) => {
                this.poligon = response;
                resolve(response);
            }, reject);
        });
    }
    addPoligon(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/add", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    updatePoligon(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/update", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    deletePoligon(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/delete", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    removeRange(pd) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/removeRange", pd)
                .subscribe((response) => {
                this.poligon = response;
                resolve(response);
            }, reject);
        });
    }
    deletePoligonDetail(pd) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/deletePoligonDetail", pd)
                .subscribe((response) => {
                this.poligon = response;
                resolve(response);
            }, reject);
        });
    }
    addDetail(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/poligons/addDetail", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getContainers(companyId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/containers/" + companyId)
                .subscribe((response) => {
                this.container = response;
                resolve(response);
            }, reject);
        });
    }
    getByPolygonsContainer(userName) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/containers/polygon?username=" + userName)
                .subscribe((response) => {
                this.container = response;
                resolve(response);
            }, reject);
        });
    }
    getAllContainerDetail(companyId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/containers/allcontainerdetail/" + companyId)
                .subscribe((response) => {
                this.container = response;
                resolve(response);
            }, reject);
        });
    }
    addContainer(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/add", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    updatedContainer(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/update", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    deleteContainer(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/delete", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    multiDeleteContainer(ids) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/containers/multiDelete", ids)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    addDevice(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/devices/add", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    addDriverProcess(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocess/add", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    updateDriverProcess(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocess/update", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    addDriverProcessDetail(entity) {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocessdetail/add", entity)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getDriverProcessControl(dpId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulations/driverprocess/controls/" + dpId)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getDriverProcessDetail(driverProcesId) {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "simulation/driverprocess/driverprocessdetail/" + driverProcesId)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getGeneralZoneReport(companyId, start, end) {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralZoneReport/" + companyId, sed)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getGeneralContainerReport(companyId, start, end, polygonId) {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralContainerReport/" + companyId + "?polygonId=" + polygonId, sed)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
    getGeneralReport(companyId, start, end, dateKey) {
        var sed = new StartEndDate();
        sed.endTime = end;
        sed.startTime = start;
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "reporting/GeneralReport/" + companyId + "?dateKey=" + dateKey, sed)
                .subscribe((response) => {
                resolve(response);
            }, reject);
        });
    }
}
SimulationService.ɵfac = function SimulationService_Factory(t) { return new (t || SimulationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppInitializationService)); };
SimulationService.ɵprov = i0.ɵɵdefineInjectable({ token: SimulationService, factory: SimulationService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SimulationService, [{
        type: Injectable
    }], function () { return [{ type: i1.HttpClient }, { type: i2.AppInitializationService }]; }, null); })();
//# sourceMappingURL=simulation.service.js.map